var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35.467,
    height: 35.467,
    viewBox: "0 0 35.467 35.467",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_59",
    "data-name": "Rectangle 59",
    width: 35.467,
    height: 35.467,
    fill: "#FFF"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_618",
    "data-name": "Groupe 618",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_622",
    "data-name": "Groupe 622",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_552",
    "data-name": "Trac\\xE9 552",
    d: "M17.734,35.467A17.734,17.734,0,1,0,0,17.734,17.733,17.733,0,0,0,17.734,35.467",
    transform: "translate(0 0)",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_553",
    "data-name": "Trac\\xE9 553",
    d: "M12.408,24.787H8.95V13.726h3.457ZM10.591,12.342h-.025A1.919,1.919,0,0,1,8.5,10.425,1.939,1.939,0,0,1,10.615,8.5a1.927,1.927,0,1,1-.024,3.838M26.238,24.787H22.318V19.063c0-1.5-.613-2.521-1.961-2.521A1.98,1.98,0,0,0,18.485,17.9a2.543,2.543,0,0,0-.084.9v5.986H14.518s.05-10.14,0-11.062H18.4v1.736a3.545,3.545,0,0,1,3.451-1.842c2.455,0,4.385,1.591,4.385,5.017Z",
    transform: "translate(0.363 0.363)",
    fill: "#015289"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLinkedin);
export default __webpack_public_path__ + "static/media/icon-linkedin.ef7f6bc2e70df2fcc42dcce1d3291bda.svg";
export { ForwardRef as ReactComponent };